<template>
  <div class="deviceMaintain">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="名称" label-width="40px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="日期选择">
        <el-date-picker
            v-model="searchForm.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button @click="goback">返回设备管理</el-button>
      <el-button type="primary" style="float: right" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i>
      </el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="maintainWay"
            label="维护方式">
        </el-table-column>
        <el-table-column
            prop="maintainCode"
            label="维护类型编码">
        </el-table-column>
        <el-table-column
            prop="maintainBy"
            label="维护人员姓名">
        </el-table-column>
        <el-table-column
            prop="maintainWorkerNumber"
            label="工号">
        </el-table-column>
        <el-table-column
            prop="note"
            label="备注">
        </el-table-column>
        <el-table-column
            prop="description"
            label="维护内容">
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="创建时间">
        </el-table-column>
        <el-table-column
            prop="maintainLevel"
            label="维护评分">
        </el-table-column>
        <el-table-column
            prop="evaluateNote"
            label="评价内容">
        </el-table-column>
        <el-table-column
            prop="evaluateTime"
            label="评价时间">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button @click="accomplishClick(scope.row)" type="text" size="small">完成保养</el-button>
            <!--            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="维护人姓名" prop="name">
          <el-input v-model="ruleForm.maintainBy" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="维护人工号">
          <el-input v-model="ruleForm.maintainWorkerNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="维护方式">
          <el-input v-model="ruleForm.maintainWay" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="营业执照">
          <el-input v-model="ruleForm.license" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码">
          <el-input v-model="ruleForm.corporateIdCard" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="法人">
          <el-input v-model="ruleForm.corporate" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="ruleForm.email" placeholder="请输入"></el-input>
        </el-form-item>
        <!--        <el-form-item label="当前版本">-->
        <!--          <el-radio-group v-model="ruleForm.currentVersion">-->
        <!--            <el-radio-button :label="true">是</el-radio-button>-->
        <!--            <el-radio-button :label="false">否</el-radio-button>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="完成保养"
        :close-on-click-modal="false"
        :visible.sync="accomplishDialog"
        width="30%">
      <el-form :model="accomplishForm" ref="accomplishForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="工人姓名" required>
          <DicInput style="width: 100%" :initName="accomplishForm.maintainBy"
                    @fieldId="accomplishFormfieldId($event,'createBy')"
                    :url="'api/Worker/Workers'"></DicInput>
        </el-form-item>
        <el-form-item label="维护内容补充" required>
          <el-input type="textarea"
                    autosize clearable v-model="accomplishForm.note" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="维护内容描述" required>
          <el-input clearable type="textarea"
                    autosize v-model="accomplishForm.description" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="accomplishDialog = false">取 消</el-button>
    <el-button type="primary" @click="accomplishForms('accomplishForm')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from '@/components/DicInput.vue';

export default {
  name: "deviceMaintain",
  data() {
    return {
      tableData: [],
      searchForm: {
        name: '',
        code: '',
        time: []
      },
      modelTitle: '新增设备维护',
      dialogVisible: false,
      accomplishDialog: false,
      accomplishForm: {
        deviceId: '',
        maintainBy: '',
        maintainWorkerNumber: '',
        createBy: '',
        note: '',
        description: ''
      },
      ruleForm: {
        name: '',
        code: '',
        currentVersion: true
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入地区', trigger: 'blur'},
        ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
        time: []
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    accomplishFormfieldId(item, name) { // 完成保养
      if (item.id) {
        this.accomplishForm[name] = item.id
        this.accomplishForm.maintainBy = item.name
        this.accomplishForm.maintainWorkerNumber = item.code
      } else {
        this.accomplishForm[name] = ''
      }
    },
    accomplishClick(row) {//完成保养
      this.rowList = row
      this.accomplishForm = {
        deviceId: row.deviceId,
        maintainBy: row.maintainBy ? row.maintainBy : '',
        maintainWorkerNumber: row.maintainWorkerNumber ? row.maintainWorkerNumber : '',
        createBy: typeof row.createBy === "number" ? row.createBy : '',
        note: '',
        description: ''
      }
      this.accomplishDialog = true
    },
    accomplishForms(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.rowList.maintainBy !== this.accomplishForm.maintainBy) {
            this.$confirm('保养人有变动，是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.accomplish(name)
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
            return
          }
          this.accomplish(name)
        } else
          return false;
      })
    },
    accomplish(name) {
      let data = {
        ...this.accomplishForm,
      }
      this.axios
          .put("api/DeviceMaintain/maintain?id=" + this.rowList.id, data).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.$refs[name].resetFields();
        this.accomplishDialog = false
        this.init()
      })
    },
    //
    addItem() {
      this.modelTitle = '新增设备维护'
      this.ruleForm = {
        name: '',
        code: '',
        currentVersion: true
      }
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑设备维护'
      this.areaId = row.id
      this.ruleForm = {
        ...row
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
          }
          if (this.modelTitle === '编辑设备维护') {
            this.axios
                .put("api/deviceMaintain?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          } else {
            this.axios
                 .post("api/deviceMaintain", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // deleteClick(flag) {
    //     let data = {
    //       id: flag.id
    //     }
    //     this.axios
    //         .put("api/deviceMaintain", {params:data}).then((res) => {
    //       this.$message({
    //         message: '操作成功',
    //         type: 'success'
    //       });
    //     }).finally(error=>{
    //       this.init()
    //     })
    // },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        deviceId: this.$route.query.deviceId,
        name: this.searchForm.name,
        code: this.searchForm.code,
        start: this.searchForm.time[0],
        end: this.searchForm.time[1],
        page: this.currPage,
        pageSize: this.pageSize,
      }
      // /DeviceMaintain/GetByGroup
      this.axios
          .get("api/deviceMaintain", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.deviceMaintain {

}
</style>